(function ($, document) {

  function onDOMContentLoaded() {
    $('.breadcrumbNavigation').on('click', '#openNavigationButton', function () {
      navigationOpener();
      return false
    });
    $('.breadcrumbNavigation').on('keypress', '#openNavigationButton', function (event) {
      if (event.which == 13) {
        navigationOpener();
        return false;
      }
    });
    $('.breadcrumbNavigation').on('click', '#crumbText', function () {
      if ($('body').width() <= 480) {
        navigationOpener();
        return false
      }
    });

    $('#openNavigationButton').siblings('.breadcrumb').find('.dropdown').on('hidden.bs.dropdown', function () {
      var parent = $('#openNavigationButton').parent('.breadcrumbNavigation');
      parent.removeClass('opened');
    })

    $('#openNavigationButton').siblings('.breadcrumb').find('.dropdown').on('shown.bs.dropdown', function () {
      var parent = $('#openNavigationButton').parent('.breadcrumbNavigation');
      parent.addClass('opened');
      resizer();
    })
  }

  function navigationOpener() {
    var parent = $('#openNavigationButton').parent('.breadcrumbNavigation');
    var dropdown = $('#openNavigationButton').siblings('.breadcrumb').find('.dropdown');
    var isLastChild = (dropdown.length === 0) ? true : false;

    if (!parent.hasClass('opened') && !dropdown.hasClass('open')) {
      parent.addClass('opened');
      resizer();
      dropdown.find('.dropdown-toggle').dropdown('toggle');
    }
    else if (parent.hasClass('opened') && dropdown.hasClass('open')) {
      parent.removeClass('opened');
      dropdown.find('.dropdown-toggle').dropdown('toggle');
    }
    // if page is the last child, there's no .dropdown to be found
    else if (parent.hasClass('opened') && isLastChild) {
      parent.removeClass('opened');
      dropdown.find('.dropdown-toggle').dropdown('toggle');
    }
    return false
  };

  function resizer() {
    var crumbPosition = $('.breadcrumbNavigation').offset();
    var height = $('.breadcrumbNavigation').height();
    $('.breadcrumbOverlay').css('top', (crumbPosition.top + height) + 'px');
    $('html').css('position', 'relative');
  }

  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery, document);